import Vue from 'vue'
import Vuex from 'vuex'
import authorization from './modules/authorization'
import piTransit from './modules/piTransit'
import otvtOrganizations from './modules/otvtOrganizations'
import arrOfIcons from '../components/json/arr_of_icons.json'
import ru from 'vee-validate/dist/locale/ru'
import moment from 'moment'
import 'moment/locale/ru'
import VeeValidate, { Validator } from 'vee-validate'


Vue.use(Vuex)

Validator.localize('ru', ru)
moment.locale('ru')

Vue.use(VeeValidate, {
    locale: 'ru',
    inject: true,
    fieldsBagName: 'veeFields',
    errorBagName: 'veeErrors'
})

export const store = new Vuex.Store({
  state: {
    files: [],
    arrOfIcons: arrOfIcons,
    screenWidth: null,
    mobile: null,
    tablet: null,
    desktop: null,
    largeDesktop: null,
    showMenu: true
  },
  actions: {
  },
  mutations: {
    updateScreenWidth (state, value) {
      state.screenWidth = value
    },
    updateMobile (state, value) {
      state.mobile = value
    },
    updateTablet (state, value) {
      state.tablet = value
    },
    updateDesktop (state, value) {
      state.desktop = value
    },
    updateLargeDesktop (state, value) {
      state.largeDesktop = value
    },
    updateFiles (state, value) {
      for (let q = 0; q < value.length; q++) {
        value[q].icon = ''
        let ext = ''
        const parts = value[q].name.split('.')
        if (parts.length > 1) ext = parts.pop()
        for (const key in state.arrOfIcons) {
          if (ext.toLowerCase().indexOf(key) !== -1) {
            value[q].icon = state.arrOfIcons[key]
            break
          }
        }
        if (!value[q].icon) {
          value[q].icon = 'fas fa-file'
        }
      }
      state.files = value
    },
    toggleMenu (state) {
      if (state.showMenu) {
        state.showMenu = false
      } else {
        state.showMenu = true
      }
    },
    hideMenu (state) {
      state.showMenu = false
    },
    displayMenu (state) {
      state.showMenu = true
    }
  },
  modules: {
    authorization,
    piTransit,
    otvtOrganizations
  }
})
